<template>
  <div class="count-area" :style="{ 'width': width, 'height': height }">
    <Input type="textarea"
      v-model.trim="innerVal"
      :placeholder="placeholder"
      :maxlength="allCount"
      @on-keyup="keyUp"
      @on-change="keyUp"
      @on-focus="focus"
      @on-blur="blur" />
    <div class="count-num" :class="{'count-num--full': isFocus && nowCount === allCount}">
      {{nowCount}}/{{allCount}}
    </div>
  </div>
</template>
<script>
export default {
  name: 'countArea',
  data() {
    return {
      innerVal: '',
      isFocus: false
    }
  },
  props: {
    placeholder: {
      type: String,
      default: '请输入'
    },
    value: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '210px'
    },
    height: {
      type: String,
      default: '86px'
    },
    allCount: {
      type: Number,
      default: 50
    }
  },
  computed: {
    nowCount() {
      return this.innerVal.length
    }
  },
  mounted() {
    this.innerVal = this.value.substring(0, this.allCount)
  },
  methods: {
    keyUp(e) {
      if (this.nowCount > this.allCount) {
        this.innerVal = this.innerVal.substring(0, this.allCount)
      }
      this.$emit('changeVal', this.innerVal)
    },
    focus() {
      this.isFocus = true
    },
    blur() {
      this.isFocus = false
    }
  },
  watch: {
    value(val) {
      this.innerVal = val.substring(0, this.allCount)
    }
  }
}
</script>

<style lang="scss">
  .count-area {
    position: relative;
    .ivu-input-wrapper {
      height: 100%;
      textarea {
        padding: 7px 10px;
        resize: none;
        height: 100%;
        font-size: 12px;
        line-height: 18px;
      }
    }
    .count-num {
      position: absolute;
      bottom: 4px;
      right: 4px;
      font-size: 12px;
      color: #C3C5C6;
      line-height: 1;
      &.count-num--full {
        color: #DC1818;
      }
    }
  }
</style>
